import { useSelector } from "react-redux";
import { ApplicationState } from "src/store";

export const useConfirmationAlertState = () => {
  return useSelector((state: ApplicationState) => state.confirmationAlert);
};
